export const EssenciaisData = [
  {
    primeiroNome: 'akavpau_prod_book',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Akamai Technologies',
    linkPolitica: 'https://www.akamai.com/uk/en/privacy-policies',
  },
  {
    primeiroNome: 'country_code',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'maersk#lang',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'da_intState',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: '30 minutos',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'CookieInformationConsent',
    segundoNome: 'www.maersk.com',
    finalidade: 'Suporta as funções técnicas do site.',
    validade: 'um ano',
    processadorDados: 'Cookie Information',
    linkPolitica: 'https://cookieinformation.com/cookie-and-privacy-policy/',
  },
  {
    primeiroNome: '_dd_s',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: '14 minutos',
    processadorDados: 'Datadog',
    linkPolitica: 'https://www.datadoghq.com/legal/privacy/',
  },
  {
    primeiroNome: 'selectedLang',
    segundoNome: 'maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'selectedLang',
    segundoNome: 'www.maersk.com',
    finalidade: 'Pendente',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'PIM-SESSION-ID',
    segundoNome: '.maersk.com',
    finalidade: 'Necessário para o site funcionar corretamente.',
    validade: 'Session',
    processadorDados: 'Akamai Technologies',
    linkPolitica: 'https://www.akamai.com/uk/en/privacy-policies',
  },
  {
    primeiroNome: 'akaalb_support_prod_maersk',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'PIM-SESSION-ID',
    segundoNome: '.maersk.com.cn',
    finalidade: 'Necessário para o site funcionar corretamente.',
    validade: 'Session',
    processadorDados: 'Akamai Technologies',
    linkPolitica: 'https://www.akamai.com/uk/en/privacy-policies',
  },
  {
    primeiroNome: 'pr_sec',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'CookieInformationConsent',
    segundoNome: 'www.maersk.com.cn',
    finalidade: 'Suporta as funções técnicas do site.',
    validade: 'um ano',
    processadorDados: 'Cookie Information',
    linkPolitica: 'https://cookieinformation.com/cookie-and-privacy-policy/',
  },
  {
    primeiroNome: 'x-maersk-tls',
    segundoNome: 'maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'CookieInformationConsentError',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'country_code',
    segundoNome: 'maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'x-maersk-tls',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'x-maersk-tls',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'maersk#lang',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'selectedLang',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'ASP.NET_SessionId',
    segundoNome: 'www.maersk.com',
    finalidade: 'Suporta a integração de uma plataforma de terceiros no site.',
    validade: 'Session',
    processadorDados: 'Microsoft, ASP.NET',
    linkPolitica: 'https://privacy.microsoft.com/en-us/privacystatement',
  },
  {
    primeiroNome: 'country_code',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'CookieInformationConsentError',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'CookieInformationConsent',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: 'Suporta as funções técnicas do site.',
    validade: 'um ano',
    processadorDados: 'Cookie Information',
    linkPolitica: 'https://cookieinformation.com/cookie-and-privacy-policy/',
  },
  {
    primeiroNome: '_op_jsTiming',
    segundoNome: '.beta.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'akavpau_prod_beta_book',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Akamai Technologies',
    linkPolitica: 'https://www.akamai.com/uk/en/privacy-policies',
  },
  {
    primeiroNome: 'opEueMonUID',
    segundoNome: '.beta.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'ASP.NET_SessionId',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: 'Suporta a integração de uma plataforma de terceiros no site.',
    validade: 'Session',
    processadorDados: 'Microsoft, ASP.NET',
    linkPolitica: 'https://privacy.microsoft.com/en-us/privacystatement',
  },
  {
    primeiroNome: 'CookieInformationConsentError',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'akaalb_support_beta_maersk',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: '_dd_s',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: '',
    validade: '15 minutos',
    processadorDados: 'Datadog',
    linkPolitica: 'https://www.datadoghq.com/legal/privacy/',
  },
  {
    primeiroNome: 'selectedLang',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: 'CookieInformationConsent',
    segundoNome: 'beta.maersk.com',
    finalidade: 'Suporta as funções técnicas do site.',
    validade: 'um ano',
    processadorDados: 'Cookie Information',
    linkPolitica: 'https://cookieinformation.com/cookie-and-privacy-policy/',
  },
  {
    primeiroNome: 'LSKey-c$CookieConsentPolicy',
    segundoNome: 'service.force.com',
    finalidade: 'Suporta a integração de uma plataforma de terceiros no site.',
    validade: 'um ano',
    processadorDados: 'Salesforce',
    linkPolitica: 'https://www.salesforce.com/eu/company/privacy',
  },
  {
    primeiroNome: 'ASP.NET_SessionId',
    segundoNome: 'beta.maersk.com',
    finalidade: 'Suporta a integração de uma plataforma de terceiros no site.',
    validade: 'Session',
    processadorDados: 'Microsoft, ASP.NET',
    linkPolitica: 'https://privacy.microsoft.com/en-us/privacystatement',
  },
  {
    primeiroNome: 'CookieConsentPolicy',
    segundoNome: 'service.force.com',
    finalidade: 'Suporta as funções técnicas do site.',
    validade: 'um ano',
    processadorDados: 'Salesforce Commerce Cloud',
    linkPolitica: 'https://www.salesforce.com/eu/company/privacy',
  },
  {
    primeiroNome: 'akavpau_prod_beta_book',
    segundoNome: 'beta.maersk.com',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Akamai Technologies',
    linkPolitica: 'https://www.akamai.com/uk/en/privacy-policies',
  },
  {
    primeiroNome: 'CookieInformationConsentError',
    segundoNome: 'beta.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/privacy',
  },
  {
    primeiroNome: '_dd_s',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: '15 minutos',
    processadorDados: 'Datadog',
    linkPolitica: 'https://www.datadoghq.com/legal/privacy/',
  },
  {
    primeiroNome: 'akaalb_support_prod_maersk',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Maersk',
    linkPolitica: 'https://terms.maersk.com/cookies',
  },
  {
    primeiroNome: 'akavpau_prod_book',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'Session',
    processadorDados: 'Akamai Technologies',
    linkPolitica: 'https://www.akamai.com/uk/en/privacy-policies',
  },
  {
    primeiroNome: 'ASP.NET_SessionId',
    segundoNome: 'www.maersk.com.cn',
    finalidade: 'Suporta a integração de uma plataforma de terceiros no site.',
    validade: 'Session',
    processadorDados: 'Microsoft, ASP.NET',
    linkPolitica: 'https://privacy.microsoft.com/en-us/privacystatement',
  },
]
